import "./App.css";
import { useEffect, useState } from "react";
import AuthenticatedApp from "./app/AuthenticatedApp";
import UnAuthenticatedApp from "./app/UnAuthenticatedApp";
import { useAuth } from "./context/authContext";
import { useNavigate } from "react-router-dom";
import { baseURL } from "./services/api";
import { urlBase64ToUint8Array } from "./send-sw-details";
import { useToast } from "@chakra-ui/react";
import { sendWelcomeTestNotification } from './services/notificationService';

const WEB_PUSH_PUBLIC_KEY = "BKvNbHgS5v8Zte52gho8pFEOgS0gG65hl6rCYaJhEd7ewl27DNzRFNn-M69H8Gw9dyVKK_bu9Q9TAe16Onl0nkA";
// const WEB_PUSH_PUBLIC_KEY =
//   "BL_9glFng3bdStxfOmhe7M3jT06FzBTUZsjbF8dFvBEhBslgVxay_mYJtmp8t3GevVCBzXyz-RxbkaYLSa3ZYOk";

function App() {
  const navigate = useNavigate();
  const { isLoggedin, setIsLoggedin, userInfo } = useAuth();
  const { userId } = userInfo;
  const toast = useToast();
  const [isFirstInstall, setIsFirstInstall] = useState(false);

  useEffect(() => {
    // Check if this is the first time the app is being used
    const checkFirstTimeUser = () => {
      const hasUsedBefore = localStorage.getItem('app_previously_installed');
      if (!hasUsedBefore) {
        setIsFirstInstall(true);
        localStorage.setItem('app_previously_installed', 'true');
      }
    };

    checkFirstTimeUser();
  }, []);

  useEffect(() => {
    if (!userId) return;
  
    async function subscribe() {
      try {
        // Check if already subscribed
        const sw = await navigator.serviceWorker.ready;
        const existingSubscription = await sw.pushManager.getSubscription();
        
        // If already subscribed, don't show the toast again
        if (existingSubscription) {
          console.log("Already subscribed to notifications");
          return;
        }
        
        // First request notification permission
        const permission = await Notification.requestPermission();
        
        if (permission === 'granted') {
          const push = await sw.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: urlBase64ToUint8Array(WEB_PUSH_PUBLIC_KEY),
          });
  
          const payload = { subscription: push, userId };
  
          await fetch(`${baseURL}/push-notification/notifications/subscription`, {
            method: "POST",
            body: JSON.stringify(payload),
            headers: {
              "content-type": "application/json",
            },
          });
  
          toast({
            title: "Notifications enabled",
            description: "You will now receive notifications about estate updates",
            status: "success",
            duration: 5000,
            isClosable: true,
          });
  
          // Send test welcome notification if this is a first-time install
          if (isFirstInstall) {
            setTimeout(() => {
              sendWelcomeTestNotification(userId);
            }, 3000); // Wait 3 seconds to ensure subscription is processed
          }
        } else {
          toast({
            title: "Notifications disabled",
            description: "You won't receive important updates. You can enable notifications in your settings.",
            status: "warning",
            duration: 5000,
            isClosable: true,
          });
        }
      } catch (error) {
        console.error('Error setting up notifications:', error);
        toast({
          title: "Notification setup failed",
          description: "Failed to set up notifications. You can try again in settings.",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }
    }
  }, [userId, toast, isFirstInstall]);
  
    // Rest of the effect remains the same...
  useEffect(() => {
    const token = localStorage.getItem("11p221#");
    const old = localStorage.getItem("old");
    
    const checkTokenStatus = async () => {
      try {
        const response = await fetch(`${baseURL}/security/verify-token`, {
          method: "POST", // Assuming it's a POST request
          headers: { 
            "Content-Type": "application/json" 
          },
          body: JSON.stringify({ token: token }) // Sending the token in the request body
        });
    
        if (response.status === 401) {
          // Token is invalid, log out the user
          localStorage.removeItem("11p221#");
          setIsLoggedin(false);
          navigate("/login");
        }
      } catch (error) {
        console.error("Error checking token status:", error);
      }
    };
    
    if (!token) {
      setIsLoggedin(false);

      if (old) {
        return navigate("/login");
      }
      // if (old) {
      //   return navigate("/login");
      // }
    } else {
      setIsLoggedin(true);
      checkTokenStatus();
    }
  }, [setIsLoggedin]); // eslint-disable-line

  // const token = localStorage.getItem('11p221#');

  // if (token) {
  //   const decoded = jwtDecode(token);
  //   const expiryDate = new Date(decoded.exp * 1000);
  //   console.log('expiryDate', expiryDate);
  // }

  if (isLoggedin) {
    return <AuthenticatedApp />;
  }

  return <UnAuthenticatedApp />;
}

export default App;
